module.exports = __webpack_public_path__ + "static/media/HCMM407.e576e40a.jpg";